import { alphanumeric } from '@/services/compose'
import { v4 as uuidv4 } from 'uuid'

interface WizardState {
  uuid: string
  adminPassword: string
  selectedDevice?: string
  selectedLocation?: string
  selectedNamespace?: string
  deploymentName?: string
  tokenHistory: {
    node: {
      [s: string]: string
    },
    vault: {
      [s: string]: string
    }
  }
}

const wizard = {
  state: {
    tokens: {
      node: {},
      vault: {}
    }
  }
}

export default wizard
